/* eslint-disable no-undef */

// React/Next imports
import Script from 'next/script';

const MeltingSpot = () => {
    return (
        <Script
            id="meltingspot-script"
            src="https://cdn.jsdelivr.net/npm/@meltingspot/meltingspot-js"
        />
    );
};

export default MeltingSpot;
